import { Grid } from "@material-ui/core";
import { Title, useAuthenticated } from "react-admin";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ProLogsDateFnsUtils from "../../../common/datetime/ProLogsDateFnsUtils";
import {
  FuelEconomyReportProvider,
  useFuelEconomyReport,
} from "./FuelEconomyReportContext";
import { ReportDashboardPickers } from "../common/ReportDashboardPickers";
import { FuelEconomyBaseMetricsWidget } from "./FuelEconomyBaseMetricsWidget";
import WorstPerformanceWidget from "./WorstPerformanceWidget";
import FuelEconomyByActionWidget from "./FuelEconomyByActionWidget";
import FuelConsumptionWidget from "./FuelConsumptionWidget";
import { AverageFuelConsumptionEfficiencyWidget } from "./AverageFuelConsumptionEfficiencyWidget";
import FuelDriversTableWidget from "./FuelDriversTableWidget";
import FuelEconomyGraphWidget from "./FuelEconomyGraphWidget";

const FuelEconomyReportContent = () => {
  useAuthenticated();
  const { reportParams } = useFuelEconomyReport();

  return (
    <div className="content-container">
      <Title title="resources.reports.fuelEconomy.name" />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ReportDashboardPickers />
        </Grid>

        <Grid item xs={12} md={5}>
          <FuelEconomyBaseMetricsWidget {...reportParams} />
        </Grid>

        <Grid item xs={12} md={7}>
          <FuelEconomyGraphWidget {...reportParams} />
        </Grid>

        <Grid item xs={12}>
          <FuelConsumptionWidget {...reportParams} />
        </Grid>

        <Grid item xs={12} md={6} style={{ display: "flex" }}>
          <FuelEconomyByActionWidget {...reportParams} />
        </Grid>
        <Grid item xs={12} md={6} style={{ display: "flex" }}>
          <WorstPerformanceWidget {...reportParams} />
        </Grid>

        <Grid item xs={12}>
          <AverageFuelConsumptionEfficiencyWidget {...reportParams} />
        </Grid>

        <Grid item xs={12}>
          <FuelDriversTableWidget {...reportParams} />
        </Grid>
      </Grid>
    </div>
  );
};

export const FuelEconomyReport = () => {
  return (
    <FuelEconomyReportProvider>
      <MuiPickersUtilsProvider utils={ProLogsDateFnsUtils}>
        <FuelEconomyReportContent />
      </MuiPickersUtilsProvider>
    </FuelEconomyReportProvider>
  );
};

export default FuelEconomyReport;
